import { render, staticRenderFns } from "./about_us.vue?vue&type=template&id=2050f4df&scoped=true"
import script from "./about_us.vue?vue&type=script&lang=js"
export * from "./about_us.vue?vue&type=script&lang=js"
import style0 from "./about_us.vue?vue&type=style&index=0&id=2050f4df&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2050f4df",
  null
  
)

export default component.exports